export default __webpack_public_path__ + "static/media/imgpost10.c9abab7a.jpg";